export const audioLibraryPath = "/phone-system/audio-library"
export const createRecordingPath = "/phone-system/audio-library/create-recording"
export const userGroupsPath = "/phone-system/user-groups"
export const userGroupPath = "/phone-system/user-groups/:groupId"
export const createUserGroupsPath = "/phone-system/user-groups/new"
export const autoAttendantPath = "/phone-system/auto-attendant"
